import React, {useContext} from 'react';
import {User} from '../../../../models/User';
import {
  Container,
  ExternalContainer,
  InnerContainer,
  HeaderTitle,
  IconButton,
  Separator,
  BackButton,
} from './styles';
import BackArrow from '../../../../assets/icons/BackArrow.svg';
import UserAvatar from '../../../atoms/UserAvatar';
import {theme} from '../../../../styles/darkTheme';
import Clock from '../../../../assets/icons/Clock.svg';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {parsePhoneNumber} from 'libphonenumber-js';
import {CLEAN_REMITTANCE, SET_REMITTANCE} from '../../../../redux/actionTypes';
import {TabSwitchContext} from '../../../../context/tabSwtich';
import {RootState} from '../../../../redux/reducers';

interface Props {
  chatName?: string;
  user?: User;
}

const ChatHeader: React.FC<Props> = ({chatName = '', user: userChat}) => {
  const {currentWatchChannel, id} = useSelector((state: RootState) => ({
    ...state.channel,
    ...state.user,
  }));
  const dispatch = useDispatch();
  const history = useNavigate();
  const {setTabSwitch} = useContext(TabSwitchContext);

  const getUserData = () => {
    const members = currentWatchChannel?.members;
    if (!members) return;
    for (let i = 0; i < members?.length || 0; i++) {
      const curr = members[i];
      if (curr.user_id !== id) {
        return curr.user;
      }
    }
    return null;
  };

  const currentUser = getUserData();

  const handleClickNewRemittance = () => {
    setNewRemittance();
    history('/request_remittance?user=true');
  };

  const setNewRemittance = () => {
    if (!currentUser) return;
    //@ts-ignore
    const phoneData = parsePhoneNumber(currentUser.phoneNumber);
    const info = {
      name: currentUser.full_name,
      countryCode: `${String(phoneData.countryCallingCode)}`,
      mobilePhone: phoneData.nationalNumber,
      emojiURL: `https://flag.pk/flags/4x3/${String(phoneData.country)}.svg`,
    };
    dispatch({type: CLEAN_REMITTANCE});
    dispatch({type: SET_REMITTANCE, payload: info});
  };

  const handleClickRepeatRemittance = () => {
    setNewRemittance();
    setTabSwitch(false);
    history('/history?user=true');
  };

  return (
    <ExternalContainer>
      <Container theme={theme}>
        <InnerContainer>
          <div onClick={() => history('/chats')}>
            <BackButton src={BackArrow} size={20} />
          </div>
          <UserAvatar size={40} src={userChat?.avatar} />
          <HeaderTitle>{chatName}</HeaderTitle>
        </InnerContainer>
        <InnerContainer align="flex-end">
          <IconButton right={5} onClick={handleClickNewRemittance} />
          <IconButton
            src={Clock}
            backgroundColor={theme.primary}
            onClick={handleClickRepeatRemittance}
          />
        </InnerContainer>
      </Container>
      <Separator theme={theme} />
    </ExternalContainer>
  );
};

export default ChatHeader;
